import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { Coin } from '../proto/coin_pb';
import { MsgJoinPool } from '../ts-client/tx_liquidity';
import { MsgJoinPool as MsgJoinPoolProto } from '../proto/tx_liquidity_pb';

const MSG_JOIN_POOL_TYPES = {
  MsgValue: [
    { name: 'sender', type: 'string' },
    { name: 'pool_id', type: 'uint64' },
    { name: 'share_out_amount', type: 'string' },
    { name: 'token_in_maxs', type: 'TypeTokenInMaxs[]' },
  ],
  TypeTokenInMaxs: [
    { name: 'denom', type: 'string' },
    { name: 'amount', type: 'string' },
  ],
};

export const createTxMsgJoinPool = (context: TxContext, params: MsgJoinPool): TxPayload => {
  const typedData = createEIP712MsgJoinPool(context, params);
  const cosmosMsg = createCosmosMsgJoinPool(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgJoinPool = (context: TxContext, params: MsgJoinPool): EIP712TypedData => {
  const types = generateTypes(MSG_JOIN_POOL_TYPES);
  const message = createMsgJoinPool(params);
  return { types, message };
};

const createCosmosMsgJoinPool = (context: TxContext, params: MsgJoinPool): any => {
  const message = new MsgJoinPoolProto({
    sender: params.sender,
    poolId: BigInt(params.poolId),
    shareOutAmount: params.shareOutAmount,
    tokenInMaxs: params.tokenInMaxs,
  });
  return { message, path: MsgJoinPoolProto.typeName };
};

export function createMsgJoinPool(params: MsgJoinPool): object | object[] {
  return {
    type: 'dymensionxyz/dymension/gamm/JoinPool',
    value: {
      sender: params.sender,
      pool_id: params.poolId.toString(),
      share_out_amount: params.shareOutAmount,
      token_in_maxs: params.tokenInMaxs,
    },
  };
}

